import { forwardRef, type Ref, type SVGProps } from "react";
const IconArchiveFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M4 14v11a3 3 0 0 0 3 3h18a3 3 0 0 0 3-3V14zm7 4a1 1 0 0 1 1 1 1 1 0 0 0 1 1h6a1 1 0 0 0 1-1 1 1 0 0 1 2 0 3 3 0 0 1-3 3h-6a3 3 0 0 1-3-3 1 1 0 0 1 1-1"
    />
    <rect width={28} height={8} x={2} y={4} fill="currentColor" rx={1} />
  </svg>
);
const ForwardRef = forwardRef(IconArchiveFilledSVG);
ForwardRef.displayName = "IconArchiveFilled";
export { ForwardRef as IconArchiveFilled };
